import { ReactNode } from 'react';

import {
  MultipleChoiceListCorrect,
  MultipleChoiceListIncorrect,
} from '../multiple-choice';
import * as Styled from './multiple-choice-radio.style';

type Props = JSX.IntrinsicElements['input'] & {
  label: ReactNode;
  isCorrect?: boolean;
  isIncorrect?: boolean;
  isSelected?: boolean;
};

const MultipleChoicePrintAnswersRadio = ({
  label,
  isCorrect,
  isIncorrect,
  isSelected,
}: Props) => {
  return (
    <Styled.MultipleChoiceRadioInputLabel>
      <Styled.MultipleChoiceRadioInputFieldWrapper>
        {isCorrect ? (
          <MultipleChoiceListCorrect />
        ) : isIncorrect ? (
          <MultipleChoiceListIncorrect />
        ) : isSelected ? (
          <Styled.MultipleChoiceRadioInputDecor $isSelected>
            <div />
          </Styled.MultipleChoiceRadioInputDecor>
        ) : (
          <Styled.MultipleChoiceRadioInputDecor>
            <div />
          </Styled.MultipleChoiceRadioInputDecor>
        )}
      </Styled.MultipleChoiceRadioInputFieldWrapper>
      <Styled.MultipleChoiceRadioInputTextWrapper>
        {label}
      </Styled.MultipleChoiceRadioInputTextWrapper>
    </Styled.MultipleChoiceRadioInputLabel>
  );
};

export default MultipleChoicePrintAnswersRadio;
